module.exports = __webpack_public_path__ + "img/co-investing6.6b81d55f.svg";